import { root } from './streams';
import { type } from './type';

export const streams = {
  ...root,
  type,
};
